import {
    AuthStatus,
    Publish,
    Pagination,
    Answer,
    Question,
    WorkSpace,
    ViewApi,
    AnswerItem,
    QuestionTypes,
    KioskPublishType,
    PortalDetail,
    PortalPublish,
} from 'interface';
import { Dispatch } from 'react';
import { toast } from 'react-toastify';
import { AnyAction } from 'redux';
import store from 'redux/store';
import { del, get, post } from 'scripts/api';
import {
    DBDestroy,
    deleteDBQuestionerAnswer,
    getDBPublishesOfflineAnswers,
    getPublishesDB,
    setPublishAnswers,
    setPublishDB,
} from 'scripts/db';
import { authToken, publishDataStatus, registeredId, userData, userFormDataStatus, WSData } from 'scripts/storage';
import { emailValidation, urlValidation } from 'scripts/validation';
import { API } from '../data';
import { setAuthStatus, setExpire, setPublishesData, setUserData, setWorkspaceData } from '../redux/actions';
import { __PostedAnswer } from './questioner/wsPanel/wsList/forms/form.interface';
import { getWorkspacesData } from './questioner/wsPanel/wsList/wsPanelList.script';
// import { offlineQuestionerSubmit } from './publishDetail/SLP/SLP.scripts';
import { getData } from 'ucheck/questioner/wsPanel/wsList/forms/forms.scripts';
import { FileManager } from 'scripts/fileManager';

export const uCheckInitialize = (dispatch: Dispatch<AnyAction>) => {
    getUser(dispatch);
};

const getUser = (dispatch: Dispatch<AnyAction>) => {
    if (!authToken.get() || !userData.get()) {
        dispatch(setAuthStatus(AuthStatus.inValid));
    } else dispatch(setAuthStatus(AuthStatus.valid));
};

export const appLogout = (dispatch: Dispatch<AnyAction>) => {
    //TODO: publish data remove
    WSData.remove();
    DBDestroy();
    dispatch(setUserData(null));
    dispatch(setWorkspaceData(null));
    dispatch(setPublishesData(null));
    dispatch(setAuthStatus(AuthStatus.inValid));
    userData.remove();
    userFormDataStatus.remove();
    publishDataStatus.removed();
    authToken.remove();
};

export const deleteRegisterCode = () => {
    return new Promise((resolve) => {
        const regiterCode = registeredId.get();
        if (regiterCode) {
            del(API.notification.devices(regiterCode))
                .then(() => resolve(true))
                .catch(() => resolve(false));
        } else resolve(true);
    });
};

export const loadUserData = (recall?: boolean) => {
    return new Promise<boolean>((resolve) => {
        const promises = [loadPublishData(), loadWorkspacesData()];
        Promise.all(promises).then((res) => {
            resolve(!res.includes(false));
            if (recall) setTimeout(() => loadUserData(recall), 2 * 60 * 1000);
        });
    });
};

export const initUserData = () => {
    if (publishDataStatus.isStored()) {
        getPublishesDB().then((publishes) => {
            store.dispatch(setPublishesData(publishes));
        });
    } else loadPublishData();
    if (WSData.get()) {
        store.dispatch(setWorkspaceData(WSData.get()));
    } else loadWorkspacesData();
};

export const loadPublishData = () => {
    return new Promise<boolean>((resolve) => {
        get<Pagination<Publish & { publish: number }>>(API.register.questionerPublishes, {
            page: 1,
            page_size: 1000,
        })
            .then((publishes) => {
                const data: Publish[] = publishes.data.data.map((i) => ({
                    id: i.publish,
                    complete_answers: i.complete_answers,
                    form: i.form,
                    title: i.title,
                    created_at: i.created_at,
                    quota: i.quota,
                }));
                downloadImages(objImgFind(data));
                setPublishDB(data);
                loadPublishAnswers(data, 0);
                resolve(true);
            })
            .catch(() => resolve(false));
    });
};

function loadPublishAnswers(publishes: Publish[], index: number) {
    return new Promise((resolve) => {
        if (index >= publishes.length) {
            store.dispatch(setPublishesData(publishes));
            resolve(true);
        }
        const publish = publishes[index];
        get<Pagination<__PostedAnswer>>(API.answers.answer, { publish: publish.id, page: 1, page_size: 10000 }).then(
            (answers) => {
                const data: Answer[] = [];
                const questions: Question[] = [];
                publish.form?.sections.map((j) =>
                    j.questions.map((k) => {
                        questions.push(k);
                        k.children?.map((o) => questions.push(o));
                    }),
                );
                answers.data.data.map((i) => {
                    data.push({
                        created_at: i.created_at,
                        modified_at: i.modified_at,
                        state: i.state,
                        id: i.id,
                        publish: i.publish,
                        form: publish.form,
                        items: i.items.map((j) => ({
                            id: j.id,
                            question: questions.filter((k) => k.id === j.question)[0],
                            value: j.value,
                            created_at: j.created_at,
                            question_items: j.question_items,
                        })),
                    });
                });
                setPublishAnswers(data).then((res) => {
                    loadPublishAnswers(publishes, index + 1).then((res) => {
                        resolve(true);
                    });
                });
            },
        );
    });
}

export const loadWorkspacesData: () => Promise<boolean> = () => {
    return new Promise((resolve) => {
        get<Pagination<WorkSpace>>(API.workSpace, { page: 1, page_size: 1000 })
            .then((res) => {
                // download new images
                downloadImages(objImgFind(res.data.data));
                WSData.set(res.data.data);
                store.dispatch(setWorkspaceData(res.data.data));
                resolve(true);
            })
            .catch((res) => {
                resolve(false);
                if (res.status >= 500) toast.error(store.getState().lang.serverErr);
                else if (res.status === 401) store.dispatch(setExpire(true));
            });
    });
};

// download all images of objects
export const objImgFind = (object: any) => {
    let urls: string[] = [];
    if (typeof object === 'object' && object !== null) {
        for (let i = 0; i < Object.keys(object).length; i++) {
            urls = [...urls, ...objImgFind(object[Object.keys(object)[i]]).filter((i) => !urls.includes(i))];
        }
    } else if (Array.isArray(object)) {
        for (let i = 0; i < object.length; i++) {
            urls = [...urls, ...objImgFind(object[i]).filter((i) => !urls.includes(i))];
        }
    } else if (
        urlValidation(object) &&
        !emailValidation(object) &&
        typeof object === 'string' &&
        !urls.includes(object)
    ) {
        urls = [...urls, object];
    }
    return urls;
};

export const downloadImages = (images: string[]) => {
    images.map((imageItem) => {
        const image = new Image();
        image.src = imageItem;
        image.onload = () => {
            // console.log(object);
        };
    });
};

export const offlineQuestionerSubmit: (recall?: boolean) => Promise<boolean> = (recall) => {
    const submitStep = 5;
    return new Promise((resolve) => {
        getDBPublishesOfflineAnswers().then((answers) => {
            const arr: Answer[][] = [];
            let row: Answer[] = [];
            answers.forEach((answer) => {
                if (row.length < submitStep) row.push(answer);
                else {
                    arr.push(row);
                    row = [];
                }
            });
            if (row.length) arr.push(row);
            groupSubmit(arr, 0).then((res) => {
                resolve(res);
                if (recall) setTimeout(() => offlineQuestionerSubmit(recall), 2 * 60 * 1000);
            });
        });
    });
};

function groupSubmit(arr: Answer[][], index: number): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
        if (index >= arr.length) {
            resolve(true);
        } else {
            Promise.all(arr[index].map((item) => answerSubmit(item))).then((res1) => {
                groupSubmit(arr, index + 1).then((res2) => {
                    resolve(!res1.includes(false) && res2);
                });
            });
        }
    });
}

function answerSubmit(data: Answer) {
    return new Promise<boolean>((resolve) => {
        post<ViewApi>(API.answers.addView, { publish: data.publish })
            .then((view) => {
                const newAnswer: Answer = { ...data };
                post<Answer>(API.answers.addAnswer, {
                    view: view.data.view_id,
                    lat: newAnswer.lat,
                    lng: newAnswer.lng,
                })
                    .then((answer) => {
                        newAnswer.access_token = answer.data.access_token;
                        newAnswer.questionerOffline = false;
                        newAnswer.id = answer.data.id;
                        submitAnswerItems(answer.data, newAnswer.items, data.form.workspace.id).then(() => {
                            deleteDBQuestionerAnswer(data.id);
                            setPublishAnswers([newAnswer]);
                            resolve(true);
                        });
                    })
                    .catch(() => resolve(false));
            })
            .catch(() => resolve(false));
    });
}

function submitAnswerItems(answer: Answer, items: AnswerItem[], ws?: string | number): Promise<boolean> {
    const answerItems = [...items];
    return new Promise((resolve) => {
        const promises: Promise<any>[] = [];
        answerItems.map((item) => {
            const objApi: any = {
                value: item.value,
                answer: answer.id,
                question: item.question?.id,
            };
            if (item.question_items) objApi.question_items = item.question_items.map((i) => i.id);
            if ([QuestionTypes.camera, QuestionTypes.file, QuestionTypes.voice].includes(item.question.input_type))
                FileManager.UploadFile(item.question, answer.access_token ?? '', ws, objApi.value).then((res) => {
                    // post answer item for file base questions if file uploaded
                    if (res && answer.access_token) {
                        objApi.value = res; // res: file url
                        promises.push(post<AnswerItem>(API.answers.answerItem(answer.access_token), objApi));
                    }
                });
            else if (answer.access_token)
                promises.push(post<AnswerItem>(API.answers.answerItem(answer.access_token), objApi));
        });
        if (!promises.length) resolve(true);
        else {
            Promise.all(promises).then(() => {
                if (answer.access_token)
                    post(API.answers.closeAnswer(answer.access_token), {}).then(() => resolve(true));
                else resolve(true);
            });
        }
    });
}
export function getPanelData(workspaces?: WorkSpace[] | null, publishes?: Publish[] | null) {
    getWorkspacesData().then((res) => {
        if (res === false) {
            if (workspaces) {
                toast.error(store.getState().lang.errorNoInternet);
                // if internet not connected , set redux to previous data
                store.dispatch(setWorkspaceData(workspaces));
            }
        } else store.dispatch(setWorkspaceData(res));
    });
    offlineQuestionerSubmit().then(() => {
        getData().then((res) => {
            if (res === false) {
                // toast.error(lang.errorNoInternet);
                if (publishes) store.dispatch(setPublishesData(publishes));
            } else store.dispatch(setPublishesData(res));
        });
    });
}

export const publishDetailToPublish = (data: KioskPublishType) => {
    const newData: Publish = {
        form: data.form,
        id: data.publish,
        title: data.title,
        created_at: data.created_at,
    };
    return newData;
};

export const newPortalToPortal = (data: PortalDetail) => {
    // const ws = data.portal.portal_publish[0].publish.form.workspace.id;
    const newData: PortalPublish = {
        id: data.id,
        uuid: data.uuid,
        title: data.title,
        // workspace: ws,
        portal: {
            id: data.portal.id,
            logo_file: data.portal.logo_file,
            background_image_file: data.portal.background_image_file,
            background_color: data.portal.background_color,
            title: data.portal.title,
            description: data.portal.description,
            column_number: data.portal.column_number,
            // workspace: ws,
            logo_size: data.portal.logo_size,
            publish_set: data.portal.portal_publish.map((item) => ({
                uuid: item.publish.uuid,
                form: item.publish.form,
            })),
        },
    };
    return newData;
};
